import { csrfToken } from "./csrf_token"

function patchImageJson(url, body) {
  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json"
    },
    body: JSON.stringify(body)
  })
}

export function patchImageAltText(url, value) {
  return patchImageJson(url, { alt_text: value ?? "" })
}

export function patchInlineImageText(url, altText, caption) {
  return patchImageJson(url, { alt_text: altText ?? "", caption: caption ?? "" })
}
